import type { Article } from "@/types/content";

export const articles: Article[] = [
  {
    id: "back-to-the-future-review",
    title: "《回到未来》：时间机器与青春期的双重冒险",
    type: "影评",
    author: "沈墨白",
    date: "2026-09-28",
    readTime: "9 分钟",
    excerpt:
      "四十一年后再看，那辆德罗宁跑车依然是最浪漫的时间机器。它真正想讲的不是物理悖论，而是一个少年如何重新认识自己的父母。",
    cover:
      "https://readdy.ai/api/search-image?query=Retro%20cinematic%20illustration%20of%20a%20silver%20sports%20car%20parked%20in%20front%20of%20a%201950s%20American%20diner%20at%20dusk%2C%20warm%20amber%20neon%20glow%2C%20painted%20vintage%20poster%20style%2C%20film%20grain%2C%20burgundy%20gold%20and%20cream%20palette%2C%20no%20text&width=900&height=560&seq=news-bttf-review&orientation=landscape",
    movieId: "back-to-the-future",
    content: [
      "1985 年 7 月，《回到未来》在北美上映。那时的暑期档属于肌肉男、爆炸与续集，没有人相信一部讲时间悖论的青春喜剧会成为整个八十年代最持久的文化符号之一。四十年后，它依然被反复重映、重看、重写，原因或许并不在于它把时间旅行讲得多严密，而在于它用一个科幻外壳，装下了一件极为私人的事：你终于有机会看清父母年轻时的样子。",
      "影片最精妙的设计，是让马蒂在 1955 年遇见十七岁的父亲。那个在 1985 年被上司呼来喝去、被同辈欺负的中年男人，年轻时原来也会写诗、也会偷偷喜欢一个女孩、也会在被人推倒后不知所措。在现实里，孩子只见过父母的「结果」；在电影里，马蒂看见了他们的「开始」。这是整部片子真正的时间旅行——不是穿越到过去，而是穿越到理解。",
      "罗伯特·泽米吉斯的调度克制得几乎狡猾。他让所有技术奇观都服从于人物关系：钟楼、闪电、滑板追逐、舞会上的吉他 solo，每一个段落都在推进同一件事——让马蒂的父母相爱。科幻在这里不是目的，而是给青春焦虑加的一层保护色。",
      "迈克尔·J·福克斯的表演是另一重关键。他并不「酷」，反而一直在慌张、出错、手忙脚乱。正是这种毛躁让观众愿意相信他：一个会搞砸一切的普通高中生，被扔进一个必须靠机智和一点运气才能活下去的局面。这份不完美，让《回到未来》在四十年后依然不像一部「老电影」，而更像一封写给所有笨拙青春的信。",
      "如果要给这部片子下一个总结，大概是：它让我们相信，过去不是用来改变的，而是用来重新认识的。那辆德罗宁最终飞向 2015 年的夜空时，观众得到的不只是一个漂亮的结尾，而是一种温柔的许可——你可以回到家里，重新看一眼那个你以为已经很熟悉的人。",
    ],
  },
  {
    id: "80s-sci-fi-golden-decade",
    title: "八十年代科幻的黄金十年：从《银翼杀手》到《异形2》",
    type: "资讯",
    author: "林知远",
    date: "2026-09-20",
    readTime: "11 分钟",
    excerpt:
      "特效技术、录像带市场与冷战末期的焦虑共同催生了八十年代科幻的爆发。这十年里，未来第一次显得既华丽又破败。",
    cover:
      "https://readdy.ai/api/search-image?query=Retro%20science%20fiction%20cityscape%20with%20neon%20signs%20reflecting%20on%20wet%20streets%20at%20night%2C%20flying%20vehicles%20in%20the%20distance%2C%20painted%20vintage%20cinematic%20illustration%2C%201980s%20film%20grain%2C%20warm%20amber%20and%20burgundy%20tones%2C%20no%20text&width=900&height=560&seq=news-scifi-decade&orientation=landscape",
    content: [
      "如果要为八十年代科幻找一个共同的视觉母题，那大概是「潮湿的霓虹」。从《银翼杀手》的洛杉矶到《异形2》的殖民地走廊，未来不再是被擦得发亮的白色乌托邦，而是漏雨、冒蒸汽、被广告牌照亮的拥挤空间。这一转向，几乎定义了此后四十年人们对「赛博朋克」的想象。",
      "技术条件是第一层原因。工业光魔在七十年代末建立的模型与光学合成体系，在八十年代进入成熟期；《终结者》用极低预算完成了液态金属之外的机械骨架动画，《异形2》则把模型、微缩与运动控制摄影推到极致。观众第一次在大银幕上看到可以被镜头仔细凝视的「未来」。",
      "第二层原因是家庭录像带的普及。院线票房失利的《银翼杀手》，正是靠录像带租赁在八十年代后期获得了第二次生命。观众可以在家里反复暂停、倒带、重看那些雨夜与霓虹，科幻片因此从「一次性奇观」变成了可以反复研究的文本。",
      "更深的一层，是冷战末期的集体情绪。核战阴影、企业权力膨胀、人与机器的边界，这些议题在八十年代科幻里反复出现。《终结者》里的机械杀手是技术失控的恐惧，《异形2》里的公司决策是资本冷酷的隐喻，而《银翼杀手》则干脆让复制人问出了最像人的问题：我是谁，我还能活多久。",
      "所以当我们今天回看这十年，会发现它留下的不只是几部经典，而是一整套关于未来的语法。后来的每一部赛博朋克作品，几乎都在和八十年代对话——要么继承它的霓虹，要么试图关掉那盏灯。",
    ],
  },
  {
    id: "the-shining-237",
    title: "《闪灵》四十六年：走廊尽头的那间 237 号房",
    type: "影评",
    author: "周迟",
    date: "2026-09-12",
    readTime: "8 分钟",
    excerpt:
      "库布里克把恐怖从「怪物」转向了「空间」。远望酒店的每一面墙、每一块地毯，都在替观众积累不安。",
    cover:
      "https://readdy.ai/api/search-image?query=Symmetrical%20hotel%20corridor%20with%20geometric%20red%20carpet%20and%20golden%20wall%20sconces%2C%20one%20point%20perspective%2C%20eerie%20empty%20space%2C%20painted%20vintage%20cinematic%20illustration%2C%20film%20grain%2C%20burgundy%20cream%20and%20gold%20tones%2C%20no%20text&width=900&height=560&seq=news-shining-corridor&orientation=landscape",
    movieId: "the-shining",
    content: [
      "《闪灵》最吓人的地方，几乎都不是「发生了什么」。真正让人后背发凉的是那些什么都没发生的镜头：空荡的走廊、整齐的几何地毯、被雪封住的大门。库布里克用极其严格的对称构图告诉观众：这个空间是被人设计过的，而设计它的人并不打算让你离开。",
      "237 号房是整部影片的核心谜题。它既是实体，也是隐喻。丹尼在门外看见的东西、杰克在房里遇见的女人、以及那条不断重复的血色走廊，共同构成了一个拒绝被解释的叙事黑洞。库布里克删掉了原著中大量的解释性内容，只留下图像与声音，让恐惧始终停留在「无法命名」的状态。",
      "表演层面，杰克·尼科尔森从一开始就处在某种临界点上。他的笑容太用力，眼神太亮，像一根被拉到极限的弦。谢莉·杜瓦尔饰演的温蒂则承受了全片最不舒服的观看体验——她的恐惧是真实的、狼狈的、没有美感的，这正是库布里克想要的：恐怖不属于怪物，而属于家庭内部。",
      "值得一提的是影片的声音设计。低频的嗡鸣、突然响起的弦乐、雪地摩托的引擎，都在不断破坏观众的呼吸节奏。很多观众记得的是画面，但真正让人不敢独处的是耳朵。",
      "四十六年过去，《闪灵》已经被拆解成无数种解读：殖民史、家庭暴力、创作焦虑、乃至登月阴谋论。这些解读未必都对，但它们证明了一件事——一部真正伟大的恐怖片，不会给你答案，只会给你一扇永远关不上的门。",
    ],
  },
  {
    id: "dead-poets-ode",
    title: "《死亡诗社》：在体制的缝隙里，站上课桌",
    type: "影评",
    author: "沈墨白",
    date: "2026-08-30",
    readTime: "7 分钟",
    excerpt:
      "它常被当作励志片引用，但真正动人的部分，是它诚实地拍出了反抗的代价。",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20old%20school%20classroom%20with%20tall%20arched%20windows%2C%20autumn%20light%20and%20dust%20in%20the%20air%2C%20wooden%20desks%20and%20a%20single%20open%20book%2C%20painted%20vintage%20cinematic%20illustration%2C%20amber%20gold%20and%20burgundy%20tones%2C%20film%20grain%2C%20no%20text&width=900&height=560&seq=news-deadpoets-ode&orientation=landscape",
    movieId: "dead-poets-society",
    content: [
      "《死亡诗社》最常被引用的台词是「Carpe Diem」，最容易出现在毕业典礼的 PPT 上。但如果只把它当作一部关于「追逐梦想」的励志片，就错过了它真正锋利的部分：它其实在讨论，当一个人被唤醒之后，他是否有能力承受醒来的后果。",
      "基廷老师并没有教学生反抗。他教的是读诗、是换一个角度看世界、是把自己的声音写下来。真正把少年们推向悬崖的，是学校、家庭与整个社会对「成功」的单一定义。影片把这三者拍得极其具体：父亲的怒吼、校长的规章、同学之间的告密，每一样都比诗歌更有力量。",
      "尼尔之死是全片最沉重的一笔，也是它区别于普通励志片的地方。电影没有把责任推给某一个恶人，而是让观众看到一套运作良好的系统如何温柔地碾压一个年轻人。基廷被解职时，学生们站上课桌的那一幕之所以动人，不是因为它代表胜利，而是因为它代表「记得」。",
      "罗宾·威廉姆斯的表演让基廷免于成为一个符号。他会开玩笑、会模仿、会尴尬，也会在走廊里露出无能为力的表情。正是这些不完美的瞬间，让这个角色不像一位布道者，而更像一个真的当过老师的人。",
    ],
  },
  {
    id: "80s-teen-soundtrack",
    title: "八十年代青春片的原声密码：合成器、鼓机与卡带",
    type: "资讯",
    author: "苏未",
    date: "2026-08-18",
    readTime: "6 分钟",
    excerpt:
      "从《早餐俱乐部》到《春天不是读书天》，约翰·休斯让流行音乐第一次成为青春片的叙事器官。",
    cover:
      "https://readdy.ai/api/search-image?query=Retro%201980s%20bedroom%20desk%20with%20a%20cassette%20tape%20player%2C%20vinyl%20records%20and%20headphones%2C%20warm%20afternoon%20light%20through%20blinds%2C%20painted%20vintage%20cinematic%20illustration%2C%20amber%20and%20burgundy%20tones%2C%20film%20grain%2C%20no%20text&width=900&height=560&seq=news-teen-soundtrack&orientation=landscape",
    movieId: "the-breakfast-club",
    content: [
      "在八十年代的青春片里，音乐不是背景，而是角色。约翰·休斯几乎每一部作品都会留出一段纯粹的「听歌时间」：人物不说话，镜头只是跟着他们在房间里走、在车里晃、在走廊上跳舞。这种处理在今天看来依然大胆，因为它相信观众可以从一首歌里读懂一个人。",
      "合成器与鼓机是那个年代的底色。它们便宜、易得，音色带着一种冰冷的明亮感，恰好对应了青少年那种「我很孤独但我不想说」的状态。当 Simple Minds 的鼓点响起，配合《早餐俱乐部》结尾那个空荡荡的操场，观众感受到的不是励志，而是一种被留在原地的怅然。",
      "卡带文化也改变了电影的传播方式。观众会把电影里的歌录成 mixtape，在随身听里反复播放；电影于是从两个小时的故事，变成了可以随身携带的情绪。这种「二次传播」在八十年代极为普遍，也让青春片的生命力远远超出了院线档期。",
      "今天的电影依然在用流行歌，但很少再有那种耐心：让一首歌完整地播完，让角色只是听着，什么也不做。或许我们怀念的不只是合成器音色，而是那种愿意把时间交给音乐的从容。",
    ],
  },
  {
    id: "die-hard-redefine",
    title: "《虎胆龙威》如何重新定义了动作英雄",
    type: "影评",
    author: "高远",
    date: "2026-08-06",
    readTime: "8 分钟",
    excerpt:
      "在史泰龙与施瓦辛格的时代，布鲁斯·威利斯做了一件反常的事：他让英雄疼、让英雄怕、让英雄抱怨。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20glass%20office%20tower%20at%20night%20seen%20from%20below%20with%20warm%20amber%20windows%2C%20lone%20silhouette%20on%20a%20high%20floor%2C%20painted%20vintage%20cinematic%20illustration%2C%20burgundy%20and%20gold%20tones%2C%20film%20grain%2C%20no%20text&width=900&height=560&seq=news-diehard-hero&orientation=landscape",
    movieId: "die-hard",
    content: [
      "1988 年之前，好莱坞动作片的主角大多是超级身体：肌肉、沉默、几乎不会受伤。布鲁斯·威利斯出现时，电视机里的他甚至还带着一点喜剧演员的松弛感。正是这种「不像英雄」的气质，让《虎胆龙威》成为了一部改写类型的电影。",
      "影片最著名的设定是「赤脚」。这个细节几乎决定了整部片的质感：玻璃渣、通风管道、血迹，观众能清楚地感到疼。麦卡伦不是不会害怕，他一直在害怕；他只是没有退路。这种「被迫勇敢」比天生的无畏更有说服力。",
      "反派汉斯·格鲁伯同样是革命性的。艾伦·瑞克曼把这个角色演成了一个有品味、有幽默感、甚至有点迷人的知识分子。他不是纯粹的恶，而是一个把犯罪当作职业的人。正是这种复杂性，让此后三十年的动作片反派都有了参照系。",
      "更隐蔽的一层，是影片对男性气质的处理。麦卡伦飞往洛杉矶是为了挽回婚姻，他在整部片里不断和一个不把他当回事的妻子、一个把他当笑话的警察系统周旋。动作场面之外，这其实是一个中年男人试图证明自己还有用的故事。",
      "所以《虎胆龙威》的伟大不在于爆炸更大，而在于它让英雄回到了人的尺寸。后来的动作片可以更炫、更快、更贵，但很少再有人能像 1988 年那样，让一个满身是伤的普通人爬进通风管道。",
    ],
  },
  {
    id: "vhs-second-life",
    title: "录像带时代：八十年代电影的第二条生命",
    type: "资讯",
    author: "林知远",
    date: "2026-07-24",
    readTime: "7 分钟",
    excerpt:
      "很多八十年代经典在院线并不成功，是录像带租赁店让它们活了下来，并最终进入了电影史。",
    cover:
      "https://readdy.ai/api/search-image?query=Retro%20video%20rental%20store%20shelves%20filled%20with%20vhs%20tapes%2C%20warm%20fluorescent%20light%2C%20carpet%20and%20neon%20sign%20glow%2C%20painted%20vintage%20cinematic%20illustration%2C%20amber%20and%20burgundy%20tones%2C%20film%20grain%2C%20no%20text&width=900&height=560&seq=news-vhs-era&orientation=landscape",
    content: [
      "八十年代的家庭录像带市场，意外地成为了电影史的第二个入口。一部在院线只放映两周就下片的电影，可以在租赁店里待上三年；一个在小城市没有排片的导演，可以通过一盒磁带被全国观众看见。这种分发方式的改变，重写了「一部电影什么时候算成功」的定义。",
      "《银翼杀手》是最典型的例子。它 1982 年上映时口碑与票房双双失利，却在随后的录像带版本中逐渐积累声誉。观众可以暂停、倒带、反复观看那些雨夜与霓虹，影评人也可以在家庭环境里重新审视它。十年之后，它已经变成了科幻片的必修课。",
      "录像带还催生了一种独特的视觉文化：封面。租赁店里的观众往往先看见盒子，再决定要不要看这部电影。于是封面设计变成了一门独立的生意，夸张的字体、手绘的怪兽、被放大的明星面孔，共同构成了八十年代最容易被辨认的视觉记忆之一。",
      "今天的流媒体让一切变得更方便，却也失去了那种「在货架前犹豫半小时」的经验。我们不再需要为一盒磁带做决定，也就不再有那种偶然发现一部冷门杰作的惊喜。这或许是录像带时代留给我们最私人的遗憾。",
    ],
  },
  {
    id: "harry-sally-love",
    title: "《当哈利遇到莎莉》：用十二年学会说爱",
    type: "影评",
    author: "苏未",
    date: "2026-07-10",
    readTime: "6 分钟",
    excerpt:
      "它没有命中注定的浪漫，只有两个不擅长亲密的人，用十几年时间慢慢靠近。",
    cover:
      "https://readdy.ai/api/search-image?query=Autumn%20park%20bench%20under%20golden%20trees%20with%20fallen%20leaves%2C%20warm%20late%20afternoon%20sunlight%2C%20two%20coffee%20cups%20on%20the%20bench%2C%20painted%20vintage%20cinematic%20illustration%2C%20burgundy%20amber%20and%20cream%20tones%2C%20film%20grain%2C%20no%20text&width=900&height=560&seq=news-harrysally-love&orientation=landscape",
    movieId: "when-harry-met-sally",
    content: [
      "《当哈利遇到莎莉》最反浪漫的地方，是它花了整整十二年才让两个人在一起。中间隔着两次失败的婚姻、无数次争吵、以及一段漫长到几乎尴尬的友谊。它不相信一见钟情，只相信反复相处。",
      "影片的结构由一系列访谈片段串联：真实的老夫妻对着镜头讲述他们如何相遇。这些插入镜头看起来是纪录片，实际上全部由演员即兴演出。它们为整部电影提供了一个温柔的框架——所有的爱情故事，最后都变成了别人口中的一段回忆。",
      "哈利与莎莉的争论构成了全片的骨架：男女能不能只是朋友？这个问题在今天看来有些过时，但电影真正关心的并不是答案，而是两个人如何在争论中暴露自己的防御。哈利的犬儒、莎莉的挑剔，都是不敢靠近的伪装。",
      "梅格·瑞恩在餐厅里的那场戏已经成为影史名场面，但更动人的是结尾。哈利在新年夜跑过街道，说出那段关于「当你只想和一个人共度余生，你希望余生越快开始越好」的独白。它之所以成立，是因为观众已经陪他们走了十二年。",
      "这也是为什么这部片子直到今天依然有效：它承认爱情是慢的、笨拙的、需要练习的。它不提供奇迹，只提供时间。",
    ],
  },
];

export const articleTypes = ["全部", "影评", "资讯"] as const;